import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import styles from './ImageBlock.module.scss';
import Image from '../Image';
import i18n from '../../i18n';

const ImageBlock = ({ image, thumbnail }) => {
    const [modalIsOpen, setModalIsOpen] = useState(false);

    const openModal = () => {
        setModalIsOpen(true);
    };
    const closeModal = (e) => {
        if (e) {
            e.preventDefault();
        }

        setModalIsOpen(false);
    };

    const ESC = 27;

    useEffect(() => {
        const kb = (e) => {
            if (e.keyCode === ESC) {
                closeModal();
            }
        };
        window.addEventListener('keyup', kb);
        return () => window.removeEventListener('keyup', kb);
    }, []);

    return (
        <div className={styles['ImageBlock']}>
            {!thumbnail && (
                <div className={styles['ImageBlock__Image']}>
                    <Image {...image.image} />
                </div>
            )}
            {thumbnail && (
                <button
                    className={styles['ImageBlock__Thumbnail']}
                    onClick={() => openModal()}
                >
                    <Thumbnail {...image.image} />
                </button>
            )}
            {modalIsOpen && (
                <div
                    className={styles['ImageBlock__Modal']}
                    onClick={(e) => closeModal(e)}
                >
                    <div className={styles['ImageBlock__ModalImage']}>
                        <Image {...image.image} />
                    </div>
                    <button
                        onClick={(e) => closeModal(e)}
                        className={styles['ImageBlock__ModalClose']}
                        aria-label={i18n.t('imageGallery.close')}
                    >
                        <span className="sr-only">
                            {i18n.t('imageGallery.close')}
                        </span>
                    </button>
                </div>
            )}
        </div>
    );
};

const Thumbnail = ({ altText, file, renditions, focal }) => {
    const { x, y } = focal;
    let style = { objectPosition: `50% 50%` };

    if (x && y) {
        style = {
            objectPosition: `${x} ${y}`,
        };
    }

    const image = renditions.square ? renditions.square.src : file;

    return <img loading="lazy" src={image} alt={altText} style={style} />;
};

ImageBlock.propTypes = {
    image: PropTypes.object,
    thumbnail: PropTypes.bool,
};

ImageBlock.defaultProps = {
    image: {},
    thumbnail: false,
};

Thumbnail.propTypes = {
    altText: PropTypes.string,
    file: PropTypes.string,
    renditions: PropTypes.object,
    focal: PropTypes.object,
};

Thumbnail.defaultProps = {
    altText: '',
    file: '',
    renditions: {},
    focal: {},
};

export default ImageBlock;
